import api from './api';
import config from '../config';

const SEND_TIMEOUT = config.broadcast?.sendTimeout || 30000;

const broadcastService = {
  getSegmentCount: (segment) =>
    api.get('/admin/broadcast/count', { params: { segment } }),

  sendBroadcast: (payload) =>
    api.post('/admin/broadcast', payload, { timeout: SEND_TIMEOUT }),
};

export default broadcastService;
